import Vue from 'vue'
import VueRouter from 'vue-router'

import login from '@/views/login/index'
import index from '@/views/index/index'
import pay from '@/views/pay/index'

Vue.use(VueRouter)

// 创建对象
const routes = [
  {
    path: '/',
    // component: index
    redirect: '/index/exe'
  },
  {
    path: '/login',
    component: login
  },
  {
    path: '/index',
    component: index,
    children: [
      {
        path: 'exe',
        component: () => import('@/views/index/components/exe.vue')
      },
      {
        path: 'exe2',
        component: () => import('@/views/index/components/exe2.vue')
      },
      {
        path: 'group',
        component: () => import('@/views/group/index.vue')
      },
      {
        path: 'excel',
        component: () => import('@/views/index/components/excel.vue')
      },
      {
        path: 'word',
        component: () => import('@/views/index/components/word.vue')
      },
      {
        path: 'pdf',
        component: () => import('@/views/index/components/pdf.vue')
      },
      {
        path: 'promotion',
        component: () => import('@/views/promotion/index.vue')
      },
      {
        path: 'introduction',
        component: () => import('@/views/introduction/index.vue'),
        children: [
          {
            path: 'test',
            component: () => import('@/views/introduction/components/test.vue')
          },
          {
            path: 'model/:type/:name',
            component: () => import('@/views/introduction/components/model.vue')
          },
          {
            path: 'model',
            component: () => import('@/views/introduction/components/model.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/pay',
    component: pay
  },
  {
    path: '/personal',
    component: () => import('@/views/personal/index.vue')
  },
  {
    path: '/trial',
    component: () => import('@/views/trial/index.vue')
  },
  {
    path: '/paySuccess',
    component: () => import('@/views/pay/components/paySuccess.vue')
  },
  {
    path: '/introduction',
    component: () => import('@/views/introduction/index.vue')
  },
  {
    path: '/promotion',
    component: () => import('@/views/promotion/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
